angular.module('impactx.panel').controller('ManufacturerPanelCtrl', [
    'TranslationService',
    '$redirect',
    'AppConfiguration',
    'SearchFilterStorage',
    ManufacturerPanelCtrl]);

function ManufacturerPanelCtrl(TranslationService, $redirect, AppConfiguration, SearchFilterStorage) {
    var self = this;
    self.trns = {
        manufacturer: TranslationService.get('manufacturer')
    };

    self.showPanelLabel = AppConfiguration.get('showPanelLabels');

    self.redirectToManufacturer = function() {
        if (self.currentFilter) {
            var filter = JSON.parse(JSON.stringify(self.currentFilter));
            filter.manufacturerId = {value: self.manufacturer.id};
            filter.dialogFilter = "manufacturer";
            filter.productPageNumber = 0;
            SearchFilterStorage.setTenderFilter(self.manufacturer.id, filter);
        }
        $redirect.redirectTo(null, "/manufacturer/" + self.manufacturer.id + (self.currentFilter ? "/true" : ""));
    };
}